(function(){
const $=id=>document.getElementById(id);
const IMG=window.PLIC_IMG||{};
const src=n=>IMG[n]||"";
const eur=v=>v.toFixed(2).replace(".",",")+" €";

/* Barra superior */
const msgs=["ENVÍO GRATIS","PERFECTO PARA LLEVAR","PAGO 100% SEGURO","CABE EN TU BOLSILLO","PROTECCIÓN UPF 50+"];
if($("topTrack")) $("topTrack").innerHTML=Array(4).fill(msgs.map(m=>`<span>${m}</span>`).join("")).join("");

/* Antes y después */
document.querySelectorAll(".ba").forEach(b=>{const r=b.querySelector("input");if(r) r.addEventListener("input",()=>b.style.setProperty("--pos",r.value+"%"));});

/* Visor de fotos */
const lb=$("lb"), lbImg=$("lbImg");
if(lb){
  document.addEventListener("click",e=>{const b=e.target.closest(".rev-ph button");if(!b)return;const im=b.querySelector("img");lbImg.src=im.src;lbImg.alt=im.alt;lb.hidden=false;});
  $("lbClose").onclick=()=>lb.hidden=true; lb.onclick=e=>{if(e.target===lb)lb.hidden=true;};
  document.addEventListener("keydown",e=>{if(e.key==="Escape")lb.hidden=true;});
}

/* Carrusel de reseñas */
document.querySelectorAll(".reviews").forEach(tr=>{
  const cards=[...tr.children], ctrl=document.createElement("div"); ctrl.className="rv-ctrl";
  ctrl.innerHTML=`<div class="rv-dots">${cards.map((_,i)=>`<i class="${i?"":"on"}"></i>`).join("")}</div><div class="rv-arrows"><button type="button" aria-label="Reseña anterior">‹</button><button type="button" aria-label="Reseña siguiente">›</button></div>`;
  tr.after(ctrl);
  const dots=[...ctrl.querySelectorAll("i")], [prev,next]=ctrl.querySelectorAll("button");
  const step=()=>cards[0].getBoundingClientRect().width+18;
  const idx=()=>Math.round(tr.scrollLeft/step());
  const atEnd=()=>tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4;
  const goTo=i=>tr.scrollTo({left:i*step()});
  next.onclick=()=>atEnd()?goTo(0):goTo(idx()+1); prev.onclick=()=>goTo(Math.max(0,idx()-1));
  tr.addEventListener("scroll",()=>{const k=atEnd()?cards.length-1:idx();dots.forEach((d,j)=>d.classList.toggle("on",j===k));},{passive:true});
  /* Pasa solo cada 4 s; se para mientras el cliente lo toca o pasa el ratón */
  let paused=false;
  ["pointerenter","touchstart","focusin"].forEach(ev=>tr.addEventListener(ev,()=>paused=true,{passive:true}));
  ["pointerleave","touchend","focusout"].forEach(ev=>tr.addEventListener(ev,()=>setTimeout(()=>paused=false,3000),{passive:true}));
  if(!matchMedia("(prefers-reduced-motion: reduce)").matches) setInterval(()=>{if(!paused&&tr.offsetParent&&!document.hidden)next.onclick();},4000);
});

/* ---------- Página de producto ---------- */
const P=window.PLIC_PRODUCT;
if(!P||!$("offerList")) return;

const COLORS=[
 {n:"Negro",c:"#2f3033",img:"negro"},{n:"Beige",c:"#e9e3d3",img:"beige"},{n:"Lila",c:"#c9c2dc",img:"lila"},
 {n:"Rosa",c:"#efc6c3",img:"rosa"},{n:"Azul cielo",c:"#b8cde3",img:"azul-cielo"},{n:"Verde",c:"#c4dccb",img:"verde"}];
const SHOTS=[
 {img:"capsulas",alt:"Mini paraguas en lila, beige y rosa con sus estuches",badge:"6 colores"},
 {img:"ligero",alt:"El mini paraguas pesa menos que una manzana",badge:"190 g"},
 {img:"bolsillo",alt:"Mini paraguas beige guardado en el bolsillo",badge:"17 cm plegado"},
 {img:"bolso",alt:"Mini paraguas dentro de un bolso pequeño",badge:"Cabe en el bolso"},
 {img:"medidas",alt:"Medidas: 98 cm abierto y 17 cm plegado",badge:"98 cm abierto"},
 {img:"detalles",alt:"Detalles: tela impermeable anti-UV, varillas reforzadas y mango cómodo",badge:"UPF 50+"}];
const OFFERS=[
 {q:1,name:"1 paraguas",sub:"Para ti"},
 {q:2,name:"2 paraguas",tag:"Más vendido"},
 {q:3,name:"3 paraguas",tag:"Mejor oferta"}];
const UMB=`<i class="umb" aria-hidden="true"></i>`;
const V=(o,ci)=>P.variants[o.name+"|"+COLORS[ci].n];
OFFERS.forEach(o=>{const v=V(o,0)||{price:0};o.price=v.price;});
const single=OFFERS[0].price;
OFFERS.forEach(o=>{o.save=o.q>1?single*o.q-o.price:0;if(!o.sub)o.sub=eur(o.price/o.q)+" cada uno";});

/* Cada paraguas del pack tiene un color distinto */
let sel=1, picks=[0,1,2], view={t:"s",i:0};
const takenBy=(k,u)=>{for(let w=0;w<OFFERS[sel].q;w++) if(w!==u&&picks[w]===k) return w; return -1;};
function fixPicks(){
  const q=OFFERS[sel].q, used=new Set();
  for(let u=0;u<q;u++){
    if(used.has(picks[u])){ for(let k=0;k<COLORS.length;k++) if(!used.has(k)){picks[u]=k;break;} }
    used.add(picks[u]);
  }
}

function renderGallery(){
  const main=$("mainImg");
  if(view.t==="c"){const c=COLORS[view.i];main.innerHTML=`<img src="${src(c.img)}" alt="Mini paraguas ${c.n}"><span class="badge-img">${c.n}</span>`;}
  else{const sh=SHOTS[view.i];main.innerHTML=`<img src="${src(sh.img)}" alt="${sh.alt}"><span class="badge-img">${sh.badge}</span>`;}
  const items=[...SHOTS.map((_,i)=>({t:"s",i})),...Array.from({length:OFFERS[sel].q},(_,u)=>({t:"c",i:picks[u]}))];
  const t=$("thumbs");
  t.innerHTML=items.map(it=>{const on=it.t===view.t&&it.i===view.i;
    const im=it.t==="c"?`<img src="${src(COLORS[it.i].img)}" alt="">`:`<img src="${src(SHOTS[it.i].img)}" alt="">`;
    return `<button type="button" data-t="${it.t}" data-i="${it.i}" aria-pressed="${on}" aria-label="${it.t==="c"?COLORS[it.i].n:SHOTS[it.i].alt}">${im}</button>`;}).join("");
  t.querySelectorAll("button").forEach(b=>b.onclick=()=>{view={t:b.dataset.t,i:+b.dataset.i};renderGallery();});
}
function renderOffers(){
  const L=$("offerList");
  L.innerHTML=OFFERS.map((o,i)=>{
    const on=i===sel;
    const units=on?`<div class="units">${o.q>1?`<p class="units-note">Cada paraguas de un color distinto</p>`:""}${Array.from({length:o.q},(_,u)=>`
      <div class="unit"><div class="unit-l">${o.q>1?"Paraguas "+(u+1):"Color"}<small>${COLORS[picks[u]].n}</small></div>
      <div class="sw" role="group" aria-label="Color del paraguas ${u+1}">${COLORS.map((c,k)=>{const w=takenBy(k,u);return `<button type="button" style="background:${c.c}" data-u="${u}" data-c="${k}" aria-pressed="${picks[u]===k}"${w>=0?` disabled aria-disabled="true" class="taken" title="${c.n}: ya elegido para el paraguas ${w+1}"`:` title="${c.n}"`} aria-label="${c.n}${w>=0?" (ya elegido)":""}"></button>`;}).join("")}</div></div>`).join("")}</div>`:"";
    const save=o.save>0?` · <span class="o-save">Ahorras ${eur(o.save)}</span>`:"";
    return `<div class="offer ${on?"sel":""}">${o.tag?`<span class="tag">${o.tag}</span>`:""}
      <button type="button" role="radio" aria-checked="${on}" data-i="${i}"><span class="radio"></span>
      <span><span class="o-name"><span class="o-icons" role="img" aria-label="${o.name}">${UMB.repeat(o.q)}</span></span><span class="o-sub">${o.sub}${save}</span></span>
      <span class="o-price">${o.save>0?`<s title="Precio de ${o.q} paraguas sueltos">${eur(single*o.q)}</s>`:""}${eur(o.price)}</span></button>${units}</div>`;
  }).join("");
  L.querySelectorAll("[data-i]").forEach(b=>b.onclick=()=>{sel=+b.dataset.i;fixPicks();renderAll();});
  L.querySelectorAll(".sw button").forEach(b=>b.onclick=()=>{const u=+b.dataset.u,k=+b.dataset.c;if(takenBy(k,u)>=0)return;picks[u]=k;view={t:"c",i:k};renderAll();});
  const o=OFFERS[sel];
  $("buyPrice").textContent=eur(o.price);
  $("stickyPrice").innerHTML=`${o.save>0?`<s style="font-size:.7em;opacity:.6;margin-right:6px">${eur(single*o.q)}</s>`:""}${eur(o.price)}<small><span class="pulse"></span>Envío gratis incluido</small>`;
}
function renderAll(){renderOffers();renderGallery();}

/* Rejilla de colores */
const cg=$("colorGrid");
if(cg){
  cg.innerHTML=COLORS.map((c,i)=>`<button type="button" data-c="${i}"><img src="${src(c.img)}" alt="Mini paraguas ${c.n}" loading="lazy"><span><i style="background:${c.c}"></i>${c.n}</span></button>`).join("");
  cg.querySelectorAll("button").forEach(b=>b.onclick=()=>{
    const k=+b.dataset.c, w=takenBy(k,0);
    if(w>=0) picks[w]=picks[0];   /* si ya estaba en otro paraguas, se intercambian */
    picks[0]=k; view={t:"c",i:k}; renderAll(); $("comprar").scrollIntoView({behavior:"smooth"});});
}

/* Fechas de entrega */
const fmt=d=>d.toLocaleDateString("es-ES",{weekday:"short",day:"numeric",month:"short"});
const add=n=>{const d=new Date();d.setDate(d.getDate()+n);return d;};
if($("d0")){$("d0").textContent=fmt(add(0));$("d1").textContent=fmt(add(2));$("d2").textContent=add(7).getDate()+"–"+add(8).toLocaleDateString("es-ES",{day:"numeric",month:"short"});}

/* Comprar: añade el pack con el color de cada paraguas */
let tt;function toast(h){const t=$("toast");t.innerHTML=h;t.hidden=false;clearTimeout(tt);tt=setTimeout(()=>t.hidden=true,5000);}
let busy=false;
async function buy(){
  if(busy) return;
  const o=OFFERS[sel], v=V(o,picks[0]);
  const chosen=picks.slice(0,o.q);
  if(new Set(chosen).size!==chosen.length){toast("<b>Colores repetidos</b>Cada paraguas del pack tiene que ser de un color distinto.");return;}
  if(!v){toast("<b>No se ha podido añadir</b>Esta combinación no está disponible. Elige otro color.");return;}
  const props={}; if(o.q>1) for(let u=0;u<o.q;u++) props["Paraguas "+(u+1)]=COLORS[picks[u]].n;
  busy=true; ["buyBtn","buyBtn2"].forEach(id=>$(id)&&($(id).disabled=true));
  try{
    const items=[{id:v.id,quantity:1,properties:props}];
    if(window.PlicCart) await window.PlicCart.add(items);
    else { const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items})}); if(!r.ok) throw new Error((await r.json()).description||"Error"); location.href="/cart"; }
  }catch(err){
    toast(`<b>No se ha podido añadir al carrito</b>${err.message}. Inténtalo de nuevo.`);
  }
  busy=false; ["buyBtn","buyBtn2"].forEach(id=>$(id)&&($(id).disabled=false));
}
$("buyBtn").innerHTML='Añadir al carrito · <span id="buyPrice"></span>'; if($("buyBtn2")) $("buyBtn2").textContent="Añadir al carrito";
$("buyBtn").onclick=buy; if($("buyBtn2")) $("buyBtn2").onclick=buy;

renderAll();
})();
